import React from 'react';
import styled from 'styled-components';

import Icon from '../Icon';

const Notification = styled(({success, warning, error, info, mini, noIcon = false, children, ...props}) => (
  <div {...props}>
    {!noIcon && (
      <NotificationIcon success={success} warning={warning} error={error} info={info} />
    )}
    <div>{children}</div>
  </div>
))`
  padding: ${props => props.mini ? '0.625rem' : '1.25rem'};
  display: flex;
  color: #484848;
  border-radius: 0.375rem;
  background: ${props => {
    switch (true) {
      case props.info: return 'rgba(0, 73, 238, 0.05)';
      case props.error: return 'rgba(179, 20, 28, 0.05)';
      case props.warning: return 'rgba(255, 179, 0, 0.05)';
      default: return 'rgba(0, 173, 38, 0.05)';
    }
  }};
  border: 1px solid ${props => {
    switch (true) {
      case props.info: return 'rgba(0, 73, 238, 0.2)';
      case props.error: return 'rgba(179, 20, 28, 0.2)';
      case props.warning: return 'rgba(153, 97, 0, 0.2)';
      default: return 'rgba(0, 173, 38, 0.2)';
    }
  }};

  > div {
    line-height: 1.5;
    margin: 0;
    padding: 0;
    margin-top: 0.25rem;
    margin-left: 1rem;

    ul {
      margin: 0;
      padding: 0;
      padding-left: ${props => props.mini ? '0.5rem' : '1rem'};
    }
  }
  
  svg {
    flex: none;
  }
`;

function NotificationIcon({success, warning, error, info}) {
  switch (true) {
    case info:
      return <Icon color="#0049ee" size="2em" name="info" />

    case error:
      return <Icon color="#B4131A" size="2em" name="alert-circle" />;

    case warning:
      return <Icon color="#FFB300" size="2em" name="alert-triangle" />;

    case success:
    default:
      return <Icon color="#00AA25" size="2em" name="check" />;
  }
}

export default Notification;